<template>
  <v-card color="blue-lighten-5" class="verification-badge-card">
    <v-row no-gutters>
      <v-col cols="4" md="4">
        <v-img
          height="100"
          class="verification-badge-img"
          src="@/assets/verified-badge-new-blue.svg"
          alt="Verified Badge"
        />
      </v-col>

      <v-col cols="4" md="4">
        <div class="verification-text">
          <div class="font-primary text-base font-medium text-primary-color verification-prompt">
            Got a verified badge yet?
            <span class="font-primary text-xs font-regular text-secondary-color ml-3">Get more visibility</span>
            <v-divider class="divider-line" inset vertical />
            <span class="font-primary text-xs font-regular text-secondary-color">Enhance your credibility</span>
          </div>
        </div>
      </v-col>

      <v-col cols="4" md="4" class="text-right">
        <v-btn
          class="get-started-btn button-text"
          elevation="0"
          @click="openVerificationModal"
        >
          Get Started
        </v-btn>
      </v-col>
    </v-row>
  </v-card>

  <!-- Verification Modal Component -->
  <VerificationModalGetStarted
    v-model="showVerificationModal"
    @verification-complete="handleVerificationComplete"
  />
</template>

<script setup>
import { ref } from 'vue';
import { useFont } from '@/composables/useFont';
import VerificationModalGetStarted from './VerificationModalGetStarted.vue';

// Initialize font system
const { fontClasses } = useFont();

// State for modal visibility
const showVerificationModal = ref(false);

// Open the verification modal
const openVerificationModal = () => {
  showVerificationModal.value = true;
};

// Handle verification completion
const handleVerificationComplete = () => {
  // Here you would typically send verification data to the server
  console.log('Verification completed!');
  // You could emit an event to the parent component or show a success message

  // Optional: Show a success notification
  // this.$store.dispatch('alert/success', 'Verification completed successfully!');

  // Optional: Refresh user data or update verification status
  // this.$store.dispatch('auth/refreshUser');
};
</script>

<style scoped>
.verification-badge-card {
  margin-top: -8px;
  margin-bottom: 12px;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.verification-badge-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.verification-badge-img {
  margin-left: -60px;
  transition: transform 0.3s ease;
}

.verification-badge-img:hover {
  transform: scale(1.05);
}

.verification-text {
  margin-left: -60px;
}

.verification-prompt {
  margin-top: 40px;
  margin-left: -60px;
  /* Font styling now handled by font system classes */
}

.get-started-btn {
  margin-top: 32px;
  margin-right: 20px;
  transition: all 0.3s ease;
  /* Button text styling handled by button-text class from font system */
}

.get-started-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.divider-line {
  margin-left: 8px;
  border-opacity: 50%;
}

/* Mobile optimization */
@media (max-width: 600px) {
  .verification-badge-img,
  .verification-text,
  .verification-prompt {
    margin-left: 0;
    text-align: center;
  }

  .get-started-btn {
    margin-top: 16px;
    margin-right: 0;
    width: 100%;
  }
}

/* Responsive adjustments for better alignment */
@media (min-width: 960px) {
  .verification-badge-card {
    height: 100px;
  }

  /* Font system handles responsive font sizes automatically */
}

/* Dark mode support */
.v-theme--dark .verification-badge-card {
  background: rgba(var(--v-theme-primary-lighten-5), 0.1);
}

.v-theme--dark .verification-badge-card:hover {
  background: rgba(var(--v-theme-primary-lighten-5), 0.15);
}
</style>